/* eslint-disable */
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import BarChartIcon from '@material-ui/icons/BarChart';
import DomainIcon from '@material-ui/icons/Domain';
import PersonIcon from '@material-ui/icons/Person';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ViewListIcon from '@material-ui/icons/ViewList';
import cn from 'classnames';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import { createPlaceOrderPageLink } from '../../Pages/PlaceOrder/PlaceOrder.page.route';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_DASHBOARD_ACCOUNTS_TILE_CLICKED,
  UI_DASHBOARD_ADD_MANAGE_PEOPLE_CLICKED,
  UI_DASHBOARD_DOCKETS_TILE_CLICKED,
  UI_DASHBOARD_GENERATE_DOCKET_REPORT_CLICKED,
  UI_DASHBOARD_GENERATE_VOLUME_REPORT_CLICKED,
  UI_DASHBOARD_MY_DOCKETS_CLICKED,
  UI_DASHBOARD_MY_ORDERS_CLICKED,
  UI_DASHBOARD_ORDERS_TILE_CLICKED,
  UI_DASHBOARD_PLACE_NEW_ORDER_CLICKED,
  UI_DASHBOARD_REPORTS_TILE_CLICKED,
  UI_DASHBOARD_VIEW_MY_ACCOUNTS_CLICKED,
} from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { createAccountsPageLink } from '../Accounts/Accounts.page.route';
import { createDocketsPageLink } from '../Dockets/Dockets.page.route';
import PageLargeTopBar from '../Layouts/PageLargeTopBar';
import { createOrdersPageLink } from '../Orders/Orders.page.route';
import { createReportPageLink } from '../Report/Report.page.route';
import DashboardPagePropTypes from './Dashboard.page.props';
import dashboardPageStyles from './Dashboard.page.styles';

/**
 * DashboardPageComponent
 * @export
 * @class DashboardPageComponent
 * @extends {React.Component<DashboardPageComponentComposedProps, DashboardPageComponentState>}
 */
export class DashboardPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<DashboardPageComponentProps>}
   * @memberof DashboardPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`DashboardPage`}
   * @memberof DashboardPageComponent
   */
  static displayName = `DashboardPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof DashboardPageComponent
   */
  static propTypes = DashboardPagePropTypes;

  /**
   * Data specific to the `<DashboardPage />` instance
   * @type {DashboardPageComponentState}
   * @memberof DashboardPageComponent
   */
  state = {};

  /**
   * Render the welcome component
   * @returns {React.Component} The rendered welcome component
   * @memberof DashboardPageComponent
   */
  welcome = () => {
    const {
      classes,
      userInfo: { firstName },
    } = this.props;
    return (
      <Grid className={classes.welcomeContainer} container>
        <Grid item xs={12}>
          <Avatar className={classes.avatar}>
            <PersonIcon className={classes.personIcon} />
          </Avatar>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" data-mf-replace-inner={MFSDR} className={classes.welcomeText}>
            {`Welcome${firstName && `, ${firstName}`}`}
          </Typography>
          <Typography variant="body1" className={classes.welcomeSubText}>
            What would you like to do today?
          </Typography>
        </Grid>
      </Grid>
    );
  };

  /**
   * Report ui action
   * @param {name} name event type
   * @param {type} type event type
   * @returns {void} void
   * @memberof DashboardPageComponent
   */
  uiActionTrigger = ({ name, type }) => {
    const { actions } = this.props;
    actions.uiTriggered({
      payload: {
        data: {
          name,
        },
      },
      type,
    });
  };

  /**
   * Render menu item
   * @param {string} label menu label to be displayed
   * @param {function} onClick on click handler
   * @param {React.Component} icon optional icon to be displayed
   * @returns {React.Component} The rendered `<DashboardPage />`
   * @memberof DashboardPageComponent
   */
  renderMenuItem = ({ label, onClick, icon = <ArrowForwardIosIcon className={this.props.classes.tileMenuOptionDefaultIcon} /> }) => {
    const { classes } = this.props;
    return (
      <Button key={label} onClick={onClick} variant="contained" fullWidth elevation={0} color="secondary" className={classes.tileMenuButton}>
        <Grid container alignItems="center" className={cn(classes.flexWrapNowrap, classes.tileMenuOption)}>
          <Grid item className={cn(classes.textAlignLeft, classes.flexGrow1)}>
            <Typography variant="body1" className={classes.menuLabel}>
              {label}
            </Typography>
          </Grid>
          <Grid item>{icon}</Grid>
        </Grid>
      </Button>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<DashboardPage />`
   * @memberof DashboardPageComponent
   */
  render() {
    const { classes, history, currentAccountGlobal } = this.props;
    const grids = [
      {
        icon: () => <ViewListIcon className={classes.cardIcon} />,
        id: `dashboardMyOrders`,
        label: `Orders`,
        onTileClick: (e) => {
          this.uiActionTrigger({ name: `dashboardOrdersTileClicked`, type: UI_DASHBOARD_ORDERS_TILE_CLICKED });
          history.push(createOrdersPageLink());
        },
        menuItems: [
          {
            label: `View My Orders`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardMyOrdersClicked`, type: UI_DASHBOARD_MY_ORDERS_CLICKED });
              history.push(createOrdersPageLink());
            },
          },
          {
            label: `Place a New Order`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardPlaceNewOrderClicked`, type: UI_DASHBOARD_PLACE_NEW_ORDER_CLICKED });
              history.push(createPlaceOrderPageLink());
            },
            icon: <AddIcon className={classes.tileMenuOptionIcon} />,
          },
        ],
      },
      {
        icon: () => <ReceiptIcon className={classes.cardIcon} />,
        id: `dashboardMyDockets`,
        label: `Dockets`,
        onTileClick: (e) => {
          this.uiActionTrigger({ name: `dashboardDocketsTileClicked`, type: UI_DASHBOARD_DOCKETS_TILE_CLICKED });
          history.push(createDocketsPageLink());
        },
        menuItems: [
          {
            label: `View My Dockets`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardMyDocketsClicked`, type: UI_DASHBOARD_MY_DOCKETS_CLICKED });
              history.push(createDocketsPageLink());
            },
          },
        ],
      },
      {
        icon: () => <DomainIcon className={classes.cardIcon} />,
        id: `dashboardMyAccounts`,
        label: `Accounts`,
        onTileClick: (e) => {
          this.uiActionTrigger({ name: `dashboardAccoiuntsTileClicked`, type: UI_DASHBOARD_ACCOUNTS_TILE_CLICKED });
          history.push(`/accounts`);
        },
        menuItems: [
          {
            label: `View My Accounts`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardViewMyAccountsClicked`, type: UI_DASHBOARD_VIEW_MY_ACCOUNTS_CLICKED });
              history.push(createAccountsPageLink());
            },
          },
          {
            label: `Add/Manage People`,
            onClick: (e) => {
              e.stopPropagation();
              const url = `/account/${helpers.getNumberFromBillTo(currentAccountGlobal)}`;
              this.uiActionTrigger({ name: url, type: UI_DASHBOARD_ADD_MANAGE_PEOPLE_CLICKED });
              history.push(url);
            },
            icon: <AddIcon className={classes.tileMenuOptionIcon} />,
            hidden: helpers.getUserTypeFromBillTo(currentAccountGlobal) !== `super`,
          },
        ],
      },
      {
        icon: () => <BarChartIcon className={classes.cardIcon} />,
        id: `dashboardReports`,
        label: `Reports`,
        onTileClick: (e) => {
          this.uiActionTrigger({ name: `dashboardReportsTileClicked`, type: UI_DASHBOARD_REPORTS_TILE_CLICKED });
          history.push(`/reports`);
        },
        menuItems: [
          {
            label: `Generate a Volume Report`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardGenerateVolumeReportClicked`, type: UI_DASHBOARD_GENERATE_VOLUME_REPORT_CLICKED });
              history.push(createReportPageLink({ reportType: `volume` }));
            },
          },
          {
            label: `Generate a Docket Report`,
            onClick: (e) => {
              e.stopPropagation();
              this.uiActionTrigger({ name: `dashboardGenerateDocketReportClicked`, type: UI_DASHBOARD_GENERATE_DOCKET_REPORT_CLICKED });
              history.push(createReportPageLink({ reportType: `docket-detail` }));
            },
          },
        ],
      },
    ];

    return (
      <PageLargeTopBar
        englishTitle="Dashboard"
        largeNavBar={this.welcome()} // top bar content
        title="DashboardPage.PageTitle"
        className={classes.stickyTopBar}
      >
      <Typography variant="body1" style={{ margin: '16px 0', textAlign: 'center', backgroundColor: '#f1f8e9', padding: '8px 16px', borderRadius: 4 }}>
        <span style={{ color: '#388e3c', fontWeight: 600 }}>
          Important Pricing Update:
        </span>{' '}
        Effective <span style={{ fontWeight: 600 }}>4 May 2026</span>, a Production
        and Transport Surcharge of <span style={{ fontWeight: 600 }}>$10.06 ex GST per m³</span>{' '}
        will apply, due to the recent escalation in global energy and commodity markets which is significantly impacting production and supply chain costs.
      </Typography>

        <Grid className={classes.cardsContainer} alignItems="flex-start" component="ul" container spacing={4}>
          {grids.map((grid, i) => (
            <Grid className={cn(classes.cursorPointer, classes.listStyleNone)} onClick={grid.onTileClick} component="li" item key={i} md={3} xs={12} sm={6}>
              <Paper className={classes.clickableCard} elevation={0} id={grid.id}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <grid.icon />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" className={classes.tileTitle}>
                      {grid.label}
                    </Typography>
                  </Grid>
                  {grid.menuItems && (
                    <Grid item xs={12}>
                      {grid.menuItems.map((menuItem) => {
                        return menuItem.hidden ? null : this.renderMenuItem({ label: menuItem.label, onClick: menuItem.onClick, icon: menuItem.icon });
                      })}
                    </Grid>
                  )}
                </Grid>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </PageLargeTopBar>
    );
  }
}
const DashboardPage = compose(
  withServices,
  withRouter,
  withStyles(themeCreateInjectableStyles(dashboardPageStyles), { withTheme: true }),
  connect(
    (state) => {
      return {
        userInfo: userProfileSelector(state),
        currentAccountGlobal: getFiltersSelectedAccount(state),
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(DashboardPageComponent);

export default DashboardPage;
